import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { UiCardComponent, UiCardItemComponent } from '@markant-platform/shared/ui-card';
import { TranslocoPipe } from '@jsverse/transloco';
import { MembershipOriginInformation } from '@markant-platform/shared/user/model';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { DefaultValuePipe } from '@markant-platform/shared/util-pipes';

@Component({
  selector: 'markant-platform-organization-member-details-card-membership-origin',
  standalone: true,
  imports: [UiCardComponent, TranslocoPipe, TranslocoDatePipe, DefaultValuePipe, UiCardItemComponent],
  templateUrl: './card-membership-origin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardMembershipOriginComponent {
  membershipOrigin = input.required<MembershipOriginInformation>();

  pathOriginatedTitle: Signal<string> = computed(() => {
    const originatedFrom = this.membershipOrigin().originatedFrom;

    if (originatedFrom) {
      return `user.details.${originatedFrom === 'REGISTRATION' ? 'registeredBy' : 'invitedBy'}`;
    }

    return 'user.details.unknownOriginated';
  });

  pathOriginatedItem: Signal<string> = computed(() => {
    const originatedFrom = this.membershipOrigin().originatedFrom;
    const createdAt = this.membershipOrigin().createdAt;
    const createdByFullName = this.membershipOrigin().createdByFullName;

    if (!createdAt || !createdByFullName) {
      return 'user.details.invitationByUnknown';
    }

    return originatedFrom === 'REGISTRATION' ? 'user.details.registrationAt' : 'user.details.invitationBy';
  });
}
